// extracted by css-extract-rspack-plugin
export default {"headerCell":"T13BZ","sortable":"QzWbM","sortedByColumn":"ug9U1","rightAligned":"DCF7x","clickable":"o8jQw"};